/**
 * Single source of truth for the length of user-supplied fields.
 *
 * Mirrors `Domain.Common.FieldLengths` on the backend, which drives both the EF column
 * definitions and the `[MaxLength]` attributes on the request DTOs. Keep the two in sync:
 * exceeding a limit here is rejected by the API as a 400, and a value that slips past
 * validation fails as a SQL truncation, which surfaces to the user as an unexplained error.
 */
export const FieldLengths = {
  user: {
    email: 64,
    firstName: 64,
    lastName: 64,
    phoneNumber: 32,
    otherAccessibility: 64,
  },
  address: {
    shortLocation: 256,
    country: 64,
    unitOrApartmentNumber: 64,
    street: 64,
    suburb: 64,
    state: 64,
    postCode: 64,
  },
} as const;

// Shown under every "Other" accessibility input so the cap is visible before it is hit,
// rather than the input silently refusing further characters.
export const otherAccessibilityCounter = (value?: string | null): string =>
  `${(value ?? "").length}/${FieldLengths.user.otherAccessibility}`;
